import React from 'react'
import html from '../assets/html.png'
import css from '../assets/css.png'
import javascript from '../assets/javascript.png'
import reactImage from '../assets/react.png'
import github from '../assets/github.png'
import cplus from '../assets/c++.png'
import tailwind from '../assets/tailwind.png'
import microsoftsqlserver from '../assets/microsoftsqlserver.png'
import node from '../assets/node.png'
import mongoDB from '../assets/mongoDB.png'



function Experience() {
    const tech = [


        {
            id: 2,
            src: cplus,
            title: 'C++',
            style: 'shadow-blue-300',
            link: ''
        },



        {
            id: 4,
            src: html,
            title: 'HTML',
            style: 'shadow-orange-500',
            link: ''
        },
        {
            id: 3,
            src: css,
            title: 'CSS',
            style: 'shadow-blue-500',
            link: ''

        },

        {
            id: 5,
            src: javascript,
            title: 'JavaScript',
            style: 'shadow-yellow-500',
            link: ''
        },
        {
            id: 9,
            src: reactImage,
            title: 'React',
            style: 'shadow-blue-600',
            link: ''
        },
        {
            id: 10,
            src: tailwind,
            title: 'Tailwind',
            style: 'shadow-sky-400',
            link: ''
        },
        {
            id: 8,
            src: node,
            title: 'NodeJS',
            style: 'shadow-lime-600',
            link: ''
        },
        {
            id: 1,
            src: mongoDB,
            title: 'mongoDB',
            style: 'shadow-red-400',
            link: ''
        },

        {
            id: 11,
            src: github,
            title: 'GitHub',
            style: 'shadow-gray-400',
            link: ''
        },

    ]

    return (
        <div name='Technologies' className='w-full min-h-screen  bg-gradient-to-b from-gray-800 to-black'>
            <div className='flex flex-col  w-full h-full max-w-screen-lg p-4 mx-auto text-white'>
                <div >
                    <p className='inline p-2 text-4xl font-bold border-b-4 border-gray-500'>Technologies</p>
                    <p className='py-6 text-2xl text-gray-400'>These are the technologies I've worked with</p>
                </div>

                <div className='grid w-full grid-cols-2 gap-8 px-12 py-8 text-center sm:grid-cols-3 sm:px-0'>
                    {tech.map(({ id, src, title, style }) => (
                        <div
                            key={id}
                            className={`py-2 duration-500 rounded-lg shadow-md hover:scale-105 ${style}`}>
                            <img src={src} alt="" className='w-20 mx-auto' />
                            <p className='mt-4'>{title}</p>
                        </div>
                    ))}

                </div>
            </div>
        </div>
    )
}

export default Experience